<template>
  <app-content>
    <page-title>Fragen</page-title>
    <main id="questions">
      <div class="container">
        <p>Hier findest Du Antworten auf Fragen, die du vielleicht haben könntest. Um die Antwort
        anzusehen, klick einfach auf die Frage, die Dich interessiert. Falls Du eine Frage hast,
        deren Antwort du hier nicht finden kannst, schreib uns gern eine E-Mail an
        <a href="mailto:fragen@janine-und-johannes.de">fragen@janine-und-johannes.de</a>. Bevor du
        aber eine Mail schickst, schau erst ganz genau nach, ob deine Frage hier nicht doch
        beantwortet wird.</p>

        <div id="faq">
          <faq-item id="where" question="Wo finde ich was?" accordion="faq">
            Auf der Startseite (<router-link to="/home">Home</router-link>) findest du Informationen
            zu
            <ul>
              <li><router-link to="/#ablauf">Tagesablauf</router-link></li>
              <li><router-link to="/#anfahrt">Kirche und Location (Anfahrt)</router-link></li>
            </ul>
            Außerdem kannst du folgendes tun:
            <ul>
              <li><router-link to="/dein-beitrag/zusagen">Dich zurückmelden</router-link></li>
              <li>Die <router-link to="/dein-beitrag/wunschliste">Wunschliste</router-link>
                ansehen</li>
              <li>Einen <router-link to="/dein-beitrag/kuchen">
                Beitrag fürs Kaffeebuffet</router-link> anmelden</li>
              <li>Einen <router-link to="/dein-beitrag/programm">
                Programmbeitrag für die Feier</router-link> anmelden</li>
              <li>Vorschläge für die <router-link to="/dein-beitrag/playlist">
                Party-Playlist</router-link> machen</li>
            </ul>
            <p>Weiterhin wirst du später in der <router-link to="/galerie">Galerie</router-link>
              einige Fotos bewundern können. Du findest hier außerdem alle Informationen, die im
              Rahmen der <router-link to="/corona">Corona-Krise</router-link> wichtig sind.</p>
          </faq-item>
          <faq-item id="sleep" question="Wo kann ich übernachten?" accordion="faq">
            <p>Es gibt mehrere günstige Hotels in unmittelbarer Nähe der Location, beispielsweise
            das Intercity Hotel oder das ibis Budget. Diese und andere Möglichkeiten kannst Du auch
              bei <a :href="trivago" target="_blank">Trivago</a> finden. Außerdem gibt es das
              <a :href="hoidayInn" target="_blank">Holiday Inn Express</a>, welches am nächsten
            an der Location liegt, allerdings nicht auf Trivago auftaucht.</p>
            <p>Falls es Dir finanziell nicht möglich ist, in einem Hotel zu übernachten, lass es
              uns bis zum 22.08. unter <a href="mailto:unterkunft@janine-und-johannes.de">
                unterkunft@janine-und-johannes.de</a> wissen. Vielleicht können
              wir für Dich eine Unterkunft organisieren.
            </p>
          </faq-item>
          <faq-item id="presents" question="Wann und wo kann ich Geschenke übergeben?"
                    accordion="faq">
            <p><strong>Geladene Gäste</strong> können die Geschenke abends bei der Feier auf den
            Geschenketisch, der dort aufgebaut sein wird, ablegen.</p>

            <p>Gäste, die <strong>nur zur kirchlichen Trauung</strong> kommen, haben nach dem
            Traugottesdienst während des Kaffeetrinkens die Möglichkeit, Geschenke an uns zu
            übergeben.</p>
          </faq-item>
        </div>
      </div>
    </main>
  </app-content>
</template>

<script>
import AppContent from '@/components/technical/AppContent.vue';
import PageTitle from '@/components/PageTitle.vue';
import FaqItem from '@/components/FaqItem.vue';

import WPlannerApi from '@/mixins/wplanner-api';

export default {
  name: 'Questions',
  components: { PageTitle, AppContent, FaqItem },
  mixins: [WPlannerApi],

  data() {
    return {
      trivago: 'https://www.trivago.de/?aDateRange%5Barr%5D=2020-09-05&aDateRange%5Bdep%5D=2020-09-06&aPriceRange%5Bfrom%5D=0&aPriceRange%5Bto%5D=0&iRoomType=7&aRooms%5B0%5D%5Badults%5D=2&cpt2=4292%2F200&hasList=1&hasMap=1&bIsSeoPage=0&sortingId=1&slideoutsPageItemId=&iGeoDistanceLimit=20000&address=&addressGeoCode=&offset=0&ra=&overlayMode=',
      hoidayInn: 'https://www.hiexpress.com/hotels/de/de/find-hotels/hotel/list?fromRedirect=true&qSrt=sBR&qIta=99600701&icdv=99600701&glat=SEAR&qDest=Darmstadt,%20Germany&setPMCookies=true&dp=true&gclid=CjwKCAjw97P5BRBQEiwAGflV6bbhIi7Cp4lCuWEkrMSZofDBWo5wSxA9jIhtFn7F2Wp0UCDM1M4U2hoCM4kQAvD_BwE&cid=48836&srb_u=1',
    };
  },
};
</script>

<style lang="scss">
  main#questions {
    flex: 1 0 auto;

    padding: 1.5rem;

    text-align: left;

    #faq {
      .faq-item {
        border-bottom: none;

        &:last-child {
          border-bottom: 1px solid lightgray;
        }
      }
    }
  }
</style>
